<div *ngIf="routeCurrent.bkRouteC" class="case-info">
  <p><span class="label-text">{{'label.previousBox' | translate}}: </span> {{case.bkCaseR}}</p>
  <p class="button-flex">
    <button *ngIf="caseStatus.bkStatusR == LOADING_CASE_STATUS" class="edit-button label-text" pButton (click)="openModal()">
		{{'button.edit' | translate}}
	</button>
  </p>
  <p class="w-100"> <span class="label-text">{{'label.weight' | translate}} (Kg): </span> {{'label.grossWeight' | translate}} {{case.grossWeightInformedA | number:'1.3-3'}} - {{'label.netWeight' | translate}} {{case.netWeightA | number:'1.3-3'}}</p>
  <!-- <p>{{'label.netWeight' | translate}}: {{case.netWeightA}}kg</p> -->
  <p class="w-100"> <span class="label-text">{{'label.dimensionsX' | translate}} (m): </span> {{(case.heightQ ? case.heightQ  : 0) | number:'1.3-3'}}x{{(case.widthQ ? case.widthQ : 0) | number:'1.3-3'}}x{{(case.depthQ ? case.depthQ : 0) | number:'1.3-3'}}</p>
</div>

<case-info-edition *ngIf="isModalOpen" [case]="case" [routeCurrent]="routeCurrent" [exportF]="exportF" (onClose)="closeModal()" (successSaveCaseInfo)="onCaseInfoSave()"></case-info-edition>

